// src/app/core/navigation/navigation.config.ts
import { NavSection } from './navigation.types';
import {
  LayoutDashboard, Activity, Bell, Target,
  Handshake, PlusCircle, ClipboardCheck, StickyNote,
  Store, UserPlus, ShieldCheck, Ticket, FileText,
  BarChart3, Receipt, AlertTriangle, Download,
  Users, TrendingUp, Wallet, Mail,
  ListTodo, CheckCircle, Zap, ScrollText,
  ShieldAlert, BookOpen, Eye, Briefcase,
  DollarSign, FileSpreadsheet, SlidersHorizontal, LineChart,
  UserCog, Lock, Plug, Settings,
  GraduationCap, BookCheck, Package, Megaphone, Globe,
} from 'lucide-angular';

export const sections: NavSection[] = [
  {
    key: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, basePath: '/dashboard',
    children: [
      { label: 'Overview', path: '/dashboard', icon: LayoutDashboard },
      { label: 'Live Transactions', path: '/dashboard/live', icon: Activity },
      { label: 'Alerts', path: '/dashboard/alerts', icon: Bell },
      { label: 'KPIs', path: '/dashboard/kpis', icon: Target },
    ],
  },
  {
    key: 'deals', label: 'Deals', icon: Handshake, basePath: '/deals',
    children: [
      { label: 'Create Merchant', path: '/deals/create', icon: PlusCircle },
    ],
    groups: [
      {
        groupLabel: 'DEALS',
        items: [
          { label: 'Prospects', path: '/deals', icon: Handshake, badge: 124 },
          { label: 'Application Sent', path: '/deals/app-sent', icon: Mail, badge: 394 },
          { label: 'Application Received', path: '/deals/app-received', icon: ClipboardCheck, badge: 99 },
          { label: 'Withdraw', path: '/deals/withdraw', icon: StickyNote, badge: 5167 },
        ],
      },
      {
        groupLabel: 'UNDERWRITING',
        items: [
          { label: 'Unclaimed by UW', path: '/deals/unclaimed-uw', icon: ShieldCheck, badge: 67 },
          { label: 'In Underwriting', path: '/deals/in-uw', icon: ShieldCheck, badge: 181 },
          { label: 'Auto Appvd Apps', path: '/deals/auto-approved', icon: CheckCircle, badge: 0 },
          { label: 'Pending Approval', path: '/deals/pending-approval', icon: ClipboardCheck, badge: 135 },
          { label: 'Unclaimed by UWC', path: '/deals/unclaimed-uwc', icon: ShieldCheck, badge: 30 },
          { label: 'In UW Compliance', path: '/deals/in-uwc', icon: ShieldCheck, badge: 3 },
          { label: 'Pending Compliance', path: '/deals/pending-compliance', icon: ClipboardCheck, badge: 3 },
          { label: 'Approved', path: '/deals/approved', icon: CheckCircle, badge: 0 },
        ],
      },
      {
        groupLabel: 'BOARDING/COMPLIANCE',
        items: [
          { label: 'Unclaimed by Corp', path: '/deals/unclaimed-corp', icon: Briefcase, badge: 9 },
          { label: 'Boarding', path: '/deals/boarding', icon: UserPlus, badge: 10 },
          { label: 'PendingBoarding', path: '/deals/pending-boarding', icon: ClipboardCheck, badge: 7 },
          { label: 'Setup/Deploy', path: '/deals/setup-deploy', icon: Settings, badge: 0 },
          { label: 'Unclaimed by Installer', path: '/deals/unclaimed-installer', icon: Plug, badge: 7 },
          { label: 'Pending Install/Training', path: '/deals/pending-install', icon: Package, badge: 176 },
          { label: 'Completed', path: '/deals/completed', icon: CheckCircle, badge: 0 },
          { label: 'Merchant Install QA', path: '/deals/install-qa', icon: ClipboardCheck, badge: 137 },
          { label: 'Compliance Review', path: '/deals/compliance-review', icon: Eye, badge: 7169 },
        ],
      },
    ],
  },
  {
    key: 'merchants', label: 'Merchants', icon: Store, basePath: '/merchants',
    children: [
      { label: 'All Merchants', path: '/merchants', icon: Store },
      { label: 'Onboarding', path: '/merchants/onboarding', icon: UserPlus },
      { label: 'Underwriting / KYC', path: '/merchants/kyc', icon: ShieldCheck },
      { label: 'Tickets', path: '/merchants/tickets', icon: Ticket },
      { label: 'Documents', path: '/merchants/documents', icon: FileText },
    ],
  },
  {
    key: 'reports', label: 'Reports', icon: BarChart3, basePath: '/reports',
    children: [
      { label: 'Transaction Reports', path: '/reports', icon: BarChart3 },
      { label: 'Settlement Reports', path: '/reports/settlement', icon: Receipt },
      { label: 'Chargebacks', path: '/reports/chargebacks', icon: AlertTriangle },
      { label: 'Exports', path: '/reports/exports', icon: Download },
    ],
  },
  {
    key: 'agents', label: 'Agents', icon: Users, basePath: '/agents',
    children: [
      { label: 'Agent Directory', path: '/agents', icon: Users },
      { label: 'Agent Performance', path: '/agents/performance', icon: TrendingUp },
      { label: 'Payouts', path: '/agents/payouts', icon: Wallet },
      { label: 'Invitations', path: '/agents/invitations', icon: Mail },
    ],
  },
  {
    key: 'workflow', label: 'Workflow', icon: ListTodo, basePath: '/workflow',
    children: [
      { label: 'Work Queue', path: '/workflow', icon: ListTodo },
      { label: 'Approvals', path: '/workflow/approvals', icon: CheckCircle },
      { label: 'Automations', path: '/workflow/automations', icon: Zap },
      { label: 'Audit Trail', path: '/workflow/audit', icon: ScrollText },
    ],
  },
  {
    key: 'risk', label: 'Risk', icon: ShieldAlert, basePath: '/risk',
    children: [
      { label: 'Risk Dashboard', path: '/risk', icon: ShieldAlert },
      { label: 'Rules', path: '/risk/rules', icon: BookOpen },
      { label: 'Monitoring', path: '/risk/monitoring', icon: Eye },
      { label: 'Cases', path: '/risk/cases', icon: Briefcase },
    ],
  },
  {
    key: 'residues', label: 'Residues', icon: DollarSign, basePath: '/residues',
    children: [
      { label: 'Residual Overview', path: '/residues', icon: DollarSign },
      { label: 'Statements', path: '/residues/statements', icon: FileSpreadsheet },
      { label: 'Adjustments', path: '/residues/adjustments', icon: SlidersHorizontal },
      { label: 'Forecast', path: '/residues/forecast', icon: LineChart },
    ],
  },
  {
    key: 'system', label: 'System', icon: Settings, basePath: '/system',
    children: [],
    groups: [
      {
        groupLabel: 'MANAGE PROFILES',
        items: [
          { label: 'Profiles', path: '/system/profiles', icon: UserCog },
          { label: 'Add Profile', path: '/system/add-profile', icon: PlusCircle },
        ],
      },
      {
        groupLabel: 'MANAGE USERS',
        items: [
          { label: 'Users', path: '/system', icon: Users },
          { label: 'Add User', path: '/system/add-user', icon: PlusCircle },
          { label: 'Merchants', path: '/system/merchants', icon: Store },
          { label: 'Add Merchant User', path: '/system/add-merchant-user', icon: PlusCircle },
          { label: 'Inactive Users', path: '/system/inactive-users', icon: UserCog },
        ],
      },
      {
        groupLabel: 'HISTORY LOG',
        items: [
          { label: 'History Log', path: '/system/history', icon: ScrollText },
        ],
      },
      {
        groupLabel: 'SETTINGS',
        items: [
          { label: 'Configuration', path: '/system/configuration', icon: Settings },
          { label: 'Banks', path: '/system/banks', icon: DollarSign },
          { label: 'Email', path: '/system/email-config', icon: Mail },
          { label: 'Notifications', path: '/system/notifications', icon: Bell },
        ],
      },
    ],
  },
  {
    key: 'university', label: 'University', icon: GraduationCap, basePath: '/university',
    children: [],
    groups: [
      {
        groupLabel: 'APP AND SUPP DOCS',
        items: [
          { label: 'List All', path: '/university', icon: FileText },
          { label: 'US Merch App and Supp Docs', path: '/university/us-merch', icon: FileText },
          { label: 'Addendums', path: '/university/addendums', icon: FileText },
          { label: 'Business Funding', path: '/university/business-funding', icon: DollarSign },
          { label: 'Merchant Maintenance', path: '/university/merchant-maintenance', icon: Settings },
          { label: 'Terminal/POS Placement Form', path: '/university/terminal-pos', icon: FileText },
        ],
      },
      {
        groupLabel: 'MARKETING MATERIAL',
        items: [
          { label: 'List All', path: '/university/marketing', icon: FileText },
          { label: 'Terminal Flyers', path: '/university/terminal-flyers', icon: Megaphone },
          { label: 'POS Flyers', path: '/university/pos-flyers', icon: Megaphone },
          { label: 'Dual Pricing/Surcharge Flyers', path: '/university/dual-pricing-flyers', icon: Megaphone },
          { label: 'High Risk Flyers', path: '/university/high-risk-flyers', icon: Megaphone },
          { label: 'Corporate Overview', path: '/university/corporate-overview', icon: Briefcase },
        ],
      },
      {
        groupLabel: 'HARDWARE',
        items: [
          { label: 'List All', path: '/university/hardware', icon: FileText },
          { label: 'Terminals', path: '/university/terminals', icon: Package },
          { label: 'Pin Pads', path: '/university/pin-pads', icon: Package },
          { label: 'POS Systems', path: '/university/pos-systems', icon: Package },
          { label: 'Gateways', path: '/university/gateways', icon: Plug },
          { label: 'Mobile', path: '/university/mobile', icon: Package },
        ],
      },
      {
        groupLabel: 'TRAINING',
        items: [
          { label: 'List All', path: '/university/training', icon: FileText },
          { label: 'Sales Training', path: '/university/sales-training', icon: GraduationCap },
          { label: 'Dual Pricing/Surcharge', path: '/university/dual-pricing-training', icon: GraduationCap },
          { label: 'Merchant Hub', path: '/university/merchant-hub', icon: GraduationCap },
        ],
      },
      {
        groupLabel: 'MISCELLANEOUS',
        items: [
          { label: 'List All', path: '/university/misc', icon: FileText },
          { label: 'Release Notes', path: '/university/releases', icon: Megaphone },
        ],
      },
    ],
  },
];
